import styled, { createGlobalStyle } from 'styled-components'

const CustomStyle = createGlobalStyle`
  .modal-validation h1 {
    width: 100%;
    font-size: 36px;
    margin-bottom: 0;
    text-align: center;
  }
`
const Link = styled.a`
  color: var(--orange);
  font-weight: bold;
  &:hover {
    color: var(--orange);
  }
`
const MessageBox = styled.p`
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  padding: 20px;
  font-size: 18px;
  text-align: center;
  color: var(--dark-blue);
`

export { MessageBox, Link, CustomStyle }
